import React from "react";
const PartyLargeIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={62}
      height={62}
      viewBox="0 0 62 62"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd">
        <path d="M30 13.5s4-12-12-12" stroke="#ED1C24" strokeWidth={2.857} />
        <path
          d="M48.5 30.444s12-4 12 12"
          stroke="#00A4FF"
          strokeWidth={2.857}
        />
        <path
          d="M43 17s8 4 8-4c0-4 4-4 4-4s8 0 4-8"
          stroke="#ED1C24"
          strokeWidth={2.857}
        />
        <path d="M13 11a3.001 3.001 0 010-6 3.001 3.001 0 010 6M60.026 21.259l-1.999 1.053-.266 2.243-1.619-1.575-2.217.44 1-2.027-1.104-1.971 2.236.323 1.533-1.66.384 2.228z" />
        <path d="M40.113 1.593l-1.33 1.96.859 2.206-2.274-.66-1.833 1.5-.075-2.368-1.993-1.28 2.228-.803.602-2.29 1.452 1.871z" />
        <path
          d="M52.924 44.464s1.82 4.138 8 8"
          stroke="#ED1C24"
          strokeWidth={2.857}
        />
        <path
          d="M41.725 11.977s.596-6.393 6.811-7.953M46.13 57.658s2.16-4.187 7.16-1.568"
          stroke="#00A4FF"
          strokeWidth={2.857}
        />
        <g transform="rotate(45 2.14 33.183)">
          <path d="M0 8h42L21 55z" />
          <path d="M39 8L21 55l-3.423-8.936L32.155 8 39 8z" />
          <path
            d="M39.687 9.5L21 51.323 2.313 9.5h37.374z"
            stroke="#000"
            strokeWidth={3}
          />
          <ellipse cx={21} cy={7} rx={21} ry={7} />
          <ellipse
            stroke="#000"
            strokeWidth={3}
            cx={21}
            cy={7}
            rx={19.5}
            ry={5.5}
          />
        </g>
      </g>
    </svg>
  )
);
PartyLargeIcon.displayName = "PartyLargeIcon";
export default PartyLargeIcon;
